module.exports = __webpack_public_path__ + "static/media/lesson.8bd1cdc0.png";